/** Códigos canónicos en BD / especialistas. */
export const DELIVERY_METHOD_DB_CODES = [
  'FACE_TO_FACE',
  'TELEPHONE',
  'VIDEO',
  'CHAT',
  'TEXT',
] as const;

export type DeliveryMethodDbCode = (typeof DELIVERY_METHOD_DB_CODES)[number];

/**
 * Normaliza cualquier variante (catálogo, UI, legado) al código de BD.
 * Ej.: "Face to Face" | "PHONE" | "Telephone" → FACE_TO_FACE / TELEPHONE / …
 */
export function toDeliveryMethodDbCode(value?: string | null): string {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const withoutDiacritics = raw.normalize('NFD').replace(/\p{M}/gu, '');
  const compact = withoutDiacritics.toUpperCase().replace(/[\s-]+/g, '_');

  const aliases: Record<string, DeliveryMethodDbCode> = {
    FACE_TO_FACE: 'FACE_TO_FACE',
    FACETOFACE: 'FACE_TO_FACE',
    PRESENCIAL: 'FACE_TO_FACE',
    F2F: 'FACE_TO_FACE',

    TELEPHONE: 'TELEPHONE',
    PHONE: 'TELEPHONE',
    TELEFONICA: 'TELEPHONE',
    TELEFONO: 'TELEPHONE',

    VIDEO: 'VIDEO',
    VIDEOLLAMADA: 'VIDEO',

    CHAT: 'CHAT',

    TEXT: 'TEXT',
    TEXTO: 'TEXT',
    SMS: 'TEXT',
  };

  if (aliases[compact]) return aliases[compact];

  const lower = withoutDiacritics.toLowerCase();
  if (lower === 'face to face' || lower === 'face-to-face') return 'FACE_TO_FACE';
  if (lower === 'telephone' || lower === 'phone') return 'TELEPHONE';
  if (lower === 'video') return 'VIDEO';
  if (lower === 'chat') return 'CHAT';
  if (lower === 'text') return 'TEXT';

  return compact;
}

export function deliveryMethodsMatch(a?: string | null, b?: string | null): boolean {
  const left = toDeliveryMethodDbCode(a);
  const right = toDeliveryMethodDbCode(b);
  if (!left || !right) return false;
  return left === right;
}

export function labelForDeliveryMethodDbCode(code?: string | null): string {
  switch (toDeliveryMethodDbCode(code)) {
    case 'FACE_TO_FACE':
      return 'Presencial';
    case 'TELEPHONE':
      return 'Telefónica';
    case 'VIDEO':
      return 'Videollamada';
    case 'CHAT':
      return 'Chat';
    case 'TEXT':
      return 'Texto';
    default:
      return String(code ?? '').trim() || '—';
  }
}
